import React from "react";
import { Box } from "@mui/material";
import ShieldIcon from "../../shared/assets/icons/ShieldIcon";
import useTranslation from "../../shared/hooks/useTranslation";

const SecuredConnection = () => {
  const { translate } = useTranslation("account");
  return (
    <Box>
      <ShieldIcon className="me-2" sx={{ width: 20, height: 20 }} />
      <span className="text-14-regular">{translate("connectionSecured")}</span>
    </Box>
  );
}

export default SecuredConnection;